function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { ConsoleLogger } from './logger/Console';
export function pollUntil(condition) {
    return _pollUntil.apply(this, arguments);
}
function _pollUntil() {
    _pollUntil = _async_to_generator(function*(condition, { maxIterations, interval } = {
        maxIterations: 100,
        interval: 100
    }) {
        let counter = 0;
        const poll = function() {
            var _ref = _async_to_generator(function*(resolve, reject) {
                counter += 1;
                if (yield condition()) {
                    resolve();
                } else if (counter >= maxIterations) {
                    reject();
                } else {
                    setTimeout(()=>poll(resolve, reject), interval);
                }
            });
            return function poll(resolve, reject) {
                return _ref.apply(this, arguments);
            };
        }();
        return new Promise(poll);
    });
    return _pollUntil.apply(this, arguments);
}
export function asyncTimeout(condition, timeout) {
    return _asyncTimeout.apply(this, arguments);
}
function _asyncTimeout() {
    _asyncTimeout = _async_to_generator(function*(condition, timeout, { rejectReason } = {
        rejectReason: null
    }) {
        const timer = new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(rejectReason);
            }, timeout);
        });
        yield Promise.race([
            condition,
            timer
        ]);
    });
    return _asyncTimeout.apply(this, arguments);
}
// Shared/Page.ts appends the location search to the page ID for some reason
// we do not want to continue this behavior in the new analytics
export function getCleanedId(id) {
    // Note that cleaning the ID only removes the querystring, but importantly
    // DOES NOT lowercase the ID anymore.  The analytics.js client has logic to
    // snake case the string, so lowercasing it here would disrupt that.
    return id.split('?')[0];
}
export function createURL(urlString) {
    try {
        const url = new URL(urlString);
        return url;
    } catch (error) {
        ConsoleLogger.error('Error creating URL', error);
        return null;
    }
}
export function getHostAndPath(url) {
    const urlObj = createURL(url);
    if (!urlObj) {
        return null;
    }
    return urlObj.origin + urlObj.pathname;
}

//# sourceMappingURL=util.js.map